export default __webpack_public_path__ + "static/media/no-data.6862f5e1.svg";